import { createSelector } from "reselect";
import { initialState } from "./reducer";

const logoutDomain = (state) => state.logout || initialState;
const loginDomain = (state) => state.login || initialState;
const verifyDomain = (state) => state.verify || initialState;
const appRootDomain = (state) => state.appRoot || initialState;

/**
 * Other specific selectors
 */

/**
 * Default selector used by Login
 */

const selectLogoutData = () =>
  createSelector(logoutDomain, (subState) => subState.toJS());

const selectLoginData = () =>
  createSelector(loginDomain, (subState) => subState.toJS());

const selectVerifyData = () =>
  createSelector(verifyDomain, (subState) => subState.toJS());

const selectAppConfig = () =>
  createSelector(appRootDomain, (subState) => {
    const jsState = subState.toJS();
    return jsState.config || {};
  });

const selectAutoRefreshConfig = () =>
  createSelector(appRootDomain, (subState) => {
    const jsState = subState.toJS();
    return (
      jsState.config?.orderChecker?.autoRefresh || {
        enabled: true,
        interval: 30,
      }
    );
  });

export {
  selectLogoutData,
  selectLoginData,
  selectVerifyData,
  selectAppConfig,
  selectAutoRefreshConfig,
};
